import { render, staticRenderFns } from "./DeliveryInstructionSubcontractDetailUpload.vue?vue&type=template&id=89856fbc&"
import script from "./DeliveryInstructionSubcontractDetailUpload.vue?vue&type=script&lang=js&"
export * from "./DeliveryInstructionSubcontractDetailUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports